import { render, staticRenderFns } from "./WebhookDetail.vue?vue&type=template&id=1907f21c&scoped=true&"
import script from "./WebhookDetail.vue?vue&type=script&lang=js&"
export * from "./WebhookDetail.vue?vue&type=script&lang=js&"
import style0 from "./WebhookDetail.vue?vue&type=style&index=0&id=1907f21c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1907f21c",
  null
  
)

export default component.exports